import { TopPage } from "@/components/elements/TopPage";
import { COMPANY_CONTAINER } from "@/constants/ui";
import { ContactInfo } from "@/features/contact/components/ContactInfo";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";

type TContactDetailPageProps = {
  isCompany: boolean;
};

export const ContactDetailPage: FC<TContactDetailPageProps> = ({ isCompany }) => {
  return (
    <Stack gap={2} height="100%">
      <TopPage title="お問い合わせ管理" enablePageBack={false} />
      <Stack maxWidth={COMPANY_CONTAINER} gap={2}>
        <Typography variant="head20Semi" fontWeight={100}>
          お問い合わせフォーム
        </Typography>
        <ContactInfo isCompany={isCompany} />
      </Stack>
    </Stack>
  );
};
